import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();

  const pathMap = {
    '/trading-dashboard-overview': {
      label: 'Trading Dashboard Overview',
      parent: null
    },
    '/live-trading-feed': {
      label: 'Live Trading Feed',
      parent: { label: 'Trading Operations', path: null }
    },
    '/portfolio-performance-analytics': {
      label: 'Portfolio Performance Analytics',
      parent: { label: 'Analytics', path: null }
    },
    '/market-data-integration-hub': {
      label: 'Market Data Integration Hub',
      parent: { label: 'System Management', path: null }
    },
    '/trade-execution-management': {
      label: 'Trade Execution Management',
      parent: { label: 'Trading Operations', path: null }
    },
    '/risk-assessment-dashboard': {
      label: 'Risk Assessment Dashboard',
      parent: { label: 'Analytics', path: null }
    }
  };

  const currentPath = pathMap?.[location?.pathname];
  
  if (!currentPath) return null;

  const breadcrumbItems = [];
  
  // Add home
  breadcrumbItems?.push({
    label: 'Dashboard',
    path: '/trading-dashboard-overview',
    isHome: true
  });

  // Add parent if exists
  if (currentPath?.parent) {
    breadcrumbItems?.push({
      label: currentPath?.parent?.label,
      path: currentPath?.parent?.path,
      isParent: true
    });
  }

  // Add current page (only if not home)
  if (location?.pathname !== '/trading-dashboard-overview') {
    breadcrumbItems?.push({
      label: currentPath?.label,
      path: location?.pathname,
      isCurrent: true
    });
  }

  const handleNavigation = (path) => {
    if (path) {
      window.location.href = path;
    }
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path || item?.label}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-border" />
          )}
          
          {item?.isCurrent ? (
            <span className="text-foreground font-medium">
              {item?.label}
            </span>
          ) : (
            <button
              onClick={() => handleNavigation(item?.path)}
              className="hover:text-foreground transition-smooth focus-ring rounded px-1 py-0.5"
            >
              {item?.isHome && (
                <Icon name="Home" size={14} className="inline mr-1" />
              )}
              {item?.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;